import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogContent } from '../../ui/dialog';
import { getCrmChatAssetUrl } from '../../../utils/api';
import { getTokenSync } from '../../../utils/authStorage';
import { isMobileContainer } from '../../../utils/device';

export default function CrmChatImageModal({ open, onOpenChange, message }) {
  const [src, setSrc] = useState(null);
  const isMobile = isMobileContainer();

  useEffect(() => {
    if (!open || !message) {
      setSrc(null);
      return undefined;
    }

    const url = getCrmChatAssetUrl(message.attachment_url || message.thumbnail_url);
    if (!url) return undefined;

    let cancelled = false;
    const token = getTokenSync();

    fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then((res) => {
        if (!res.ok) throw new Error('Failed');
        return res.blob();
      })
      .then((blob) => {
        if (!cancelled) setSrc(URL.createObjectURL(blob));
      })
      .catch(() => {
        if (!cancelled) setSrc(url);
      });

    return () => {
      cancelled = true;
      if (src?.startsWith('blob:')) URL.revokeObjectURL(src);
    };
  }, [open, message]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        overlayClassName="z-[80]"
        className={`z-[80] p-0 border-0 bg-black/95 overflow-hidden ${
          isMobile ? 'max-w-[100vw] w-full h-[100dvh] rounded-none' : 'max-w-4xl'
        }`}
      >
        <button
          type="button"
          onClick={() => onOpenChange(false)}
          className="absolute top-3 right-3 z-10 h-9 w-9 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-black/70"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>
        <div className="flex items-center justify-center min-h-[50vh] p-4 animate-in zoom-in-95 fade-in duration-200">
          {src ? (
            <img
              src={src}
              alt={message?.attachment_original_name || 'Image'}
              className="max-w-full max-h-[85vh] object-contain rounded-lg"
            />
          ) : (
            <div className="text-white/70 text-sm">Loading...</div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
